import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import { UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE } from '../../../constants/payments/vault-account-types';

import styles from './styles.styl';

const RadioGroup = ({ label, name, onChange, radios, value }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.root}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.wrapper}>
        {radios.map(radio => (
          <label className={styles.radio} key={radio.value}>
            <input
              type="radio"
              name={name}
              value={radio.value}
              onChange={() => onChange(radio.value)}
              checked={radio.value === value}
              disabled={radio.isExpired}
            />
            <div
              className={cn(styles.radioLabelWrapper, {
                [styles.expired]: radio.isExpired,
              })}
            >
              <div className={styles.radioLabelWrapperHeader}>
                <div>{radio.label}</div>
                <div
                  className={cn(styles.radioAccountType, {
                    [styles.unknownAccountType]:
                      radio.accountType === UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE,
                  })}
                >
                  {radio.accountType}
                </div>
              </div>
              <div
                className={cn(styles.expDate, {
                  [styles.expDateExpired]: radio.isExpired,
                })}
              >
                {`${formatMessage({ id: 'common.expDate' })}: ${radio.expDate}`}
              </div>
              {radio.isExpired && (
                <div className={styles.expiredLabel}>
                  {formatMessage({ id: 'common.expired' })}
                </div>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

RadioGroup.propTypes = {
  label: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
  radios: PropTypes.array,
  value: PropTypes.number,
};

export default memo(RadioGroup);



// WEBPACK FOOTER //
// ./src/components/common/RadioGroup/index.jsx